import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { init as initSplitText } from "./text";
import { init as initMaskSVG } from "./mask";
import { init as initServicios } from "./servicios";
import { init as initSVGANIM } from "./svganim";
import { init as initSticky } from "./sticky";
import { init as initMainMenu } from "./mainmenu";
import { init as initMethod } from "./method";
import { init as initBanner } from "./banner";
import { init as initHeaderScroll } from "./header-scroll";
import { init as initHoverDesc } from "./hoverdesc";
import { init as initCounter } from "./counter";
import { init as initMoveLogo } from "./movelogo";
import { init as initFooterForm } from "./footer-form";
import { init as initScrollSlider } from "./scrollSlider";

gsap.registerPlugin(ScrollTrigger, SplitText);

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.SplitText = SplitText;

/**
 * Inicializa todas las animaciones GSAP que dependen del contenido del DOM.
 * Se llama en la carga inicial y tras cada transición de Barba.
 */
export function initAllGSAP() {
  if (window.ScrollTrigger) {
    initMaskSVG();
    initServicios();
    initSVGANIM();
    initSticky();
    initMainMenu();
    initMethod();
    initBanner();
    initHeaderScroll();
    initHoverDesc();
    initCounter();
    initMoveLogo();
    initFooterForm();
    initScrollSlider();
  }

  const ensureSplitText = () => {
    if (!window.SplitText) return false;
    initSplitText();
    return true;
  };

  if (!ensureSplitText()) {
    const t = setInterval(() => {
      if (ensureSplitText()) clearInterval(t);
    }, 200);
  }
}

// Inicialización en la primera carga
initAllGSAP();
